import { DisplayText, BodyText } from "../../components/mobile/primitives";

export function JourneyWelcomeScreen() {
  return (
    <div
      style={{
        padding: "0 24px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        position: "relative",
        gap: 0,
      }}
    >
      {/* Logo */}
      <DisplayText size={38} color="var(--color-kin-black)">
        Kin
      </DisplayText>
      <BodyText
        size={12}
        color="var(--color-kin-muted)"
        weight={400}
        style={{ marginTop: 2, fontStyle: "italic" }}
      >
        Their skills, your health.
      </BodyText>
      <BodyText
        size={9}
        color="var(--color-kin-muted)"
        weight={500}
        style={{ marginTop: 8, textAlign: "center", lineHeight: 1.45, maxWidth: 200 }}
      >
        First personalized insight in a few minutes.
      </BodyText>

      {/* Sign-in buttons */}
      <div
        style={{ width: "100%", marginTop: 36, display: "flex", flexDirection: "column", gap: 10 }}
      >
        {/* Google — primary */}
        <div
          style={{
            background: "#fff",
            borderRadius: 14,
            padding: "12px 0",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            border: "1px solid rgba(0,0,0,0.12)",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24">
            <path
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
              fill="var(--color-kin-google-blue)"
            />
            <path
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              fill="var(--color-kin-google-green)"
            />
            <path
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18A10.96 10.96 0 0 0 1 12c0 1.77.42 3.45 1.18 4.93l3.66-2.84z"
              fill="var(--color-kin-google-yellow)"
            />
            <path
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              fill="var(--color-kin-google-red)"
            />
          </svg>
          <BodyText size={11} color="var(--color-kin-black)" weight={700}>
            Continue with Google
          </BodyText>
        </div>

        {/* Apple — coming soon */}
        <div
          style={{
            background: "rgba(0,0,0,0.04)",
            borderRadius: 14,
            padding: "12px 0",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            border: "1px solid rgba(0,0,0,0.06)",
            opacity: 0.45,
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="var(--color-kin-black)">
            <path d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.48-3.24 0-1.44.62-2.2.44-3.06-.4C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
          </svg>
          <BodyText size={11} color="var(--color-kin-black)" weight={700}>
            Continue with Apple
          </BodyText>
          <BodyText size={7} color="var(--color-kin-muted)" weight={600} style={{ marginLeft: 2 }}>
            Soon
          </BodyText>
        </div>

        {/* Outlook — coming soon */}
        <div
          style={{
            background: "rgba(0,0,0,0.04)",
            borderRadius: 14,
            padding: "12px 0",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            border: "1px solid rgba(0,0,0,0.06)",
            opacity: 0.45,
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <rect
              x="3"
              y="5"
              width="18"
              height="14"
              rx="2"
              fill="var(--color-kin-microsoft-blue)"
            />
            <path
              d="M3 7l9 6 9-6"
              stroke="#fff"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
          <BodyText size={11} color="var(--color-kin-black)" weight={700}>
            Continue with Outlook
          </BodyText>
          <BodyText size={7} color="var(--color-kin-muted)" weight={600} style={{ marginLeft: 2 }}>
            Soon
          </BodyText>
        </div>
      </div>

      {/* Footer */}
      <div style={{ width: "100%", marginTop: "auto" }}>
        <BodyText
          size={8}
          color="var(--color-kin-muted)"
          weight={400}
          style={{ textAlign: "center", lineHeight: 1.5 }}
        >
          Your data stays private. Always.
        </BodyText>
      </div>
    </div>
  );
}
